import React, { useContext, useState } from 'react';
import styles from './index.module.less';
import { IStudyToolResult } from '@/types';
import { bindEvents } from '@/utils/sensors-data';
import SensorsDataContext from '@/components/home/context';
import { useMount } from 'ahooks';
import { getUserCheck } from '@/apis';

declare global {
    interface Window {
        zc: any;
        cbk: any;
    }
}

function soboten() {
    window.zc = function () {
        window.cbk = window.cbk || [];
        window.cbk.push(arguments);
    };
    const x = document.createElement('script');
    x.async = true;
    x.id = 'zhichiScript';
    x.className = 'zhiCustomBtn';
    x.src = 'https://gaodun.soboten.com/chat/frame/v2/entrance.js?sysnum=419372cc84534f6e84bdd400c415049f';
    document.body.appendChild(x);
}

interface IProps {
    dataSource: IStudyToolResult['learningTools'];
}

const LearningTools = (props: IProps) => {
    const [userCheck, setUserCheck] = useState<{ commonPrice: boolean; talkLink: string }>({ commonPrice: false, talkLink: '' });
    const sensorsDataContextValues = useContext(SensorsDataContext);

    const handleClick = (data: IStudyToolResult['learningTools'][number]) => {
        bindEvents('pc_studytab_toolbar_click', {
            ...sensorsDataContextValues,
            icon_name: data.iconName,
            icon_id: data.toolId,
        });

        if (data.jumpLink === 'after_sale') {
            if (userCheck.commonPrice) {
                window.zc('frame_manual', function (res: any) {});
                return;
            }
            window.open(userCheck.talkLink, '_blank');
        } else if (data.jumpLink) {
            window.open(data.jumpLink, '_blank');
        }
    };

    useMount(async () => {
        const studentId = sensorsDataContextValues?.student_id;

        soboten();
        window.zc('config', {
            manual: true, // 设置成手动初始化
            custom: true, // 自定义按钮
            anchor: true, // true 新窗口打开咨询页 false 打开悬浮窗咨询页（默认值）
            type: 3, // 去掉人工按钮
            auto_expand: true, // 聊天组件在访客来访时自动弹出
            show_manual: true, // 聊了几次后 在转人工
            partnerid: `USER-${studentId}`, // 用户id
        });

        const response = await getUserCheck();
        if (response.status === 0) {
            setUserCheck(response.result);
        }
    });

    return (
        <div className={styles['learning-tools-wrap']}>
            <div className={styles['learning-tools-head']}>
                <div>学习工具</div>
            </div>
            <div className={styles['learning-tools-body']}>
                <div className={styles['learning-tools-list']}>
                    {props.dataSource.map(item => (
                        <div className={styles['learning-tools-list-item']} key={item.toolId} onClick={() => handleClick(item)}>
                            <div className={styles['learning-tools-list-item-icon']}>
                                <img src={item.iconSrc} alt="" />
                            </div>
                            <div className={styles['learning-tools-list-item-name']}>{item.iconName || ''}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LearningTools;
